/**
* Common - UI
*/

import {
  isEmpty,
} from './Utils';

import {
  create as banner,
} from './molecule/banner';

/**
 * Tests & renders a key from a node JSON object; displays an error message if necessary.
 *
 * @param {Object} node - The object containing the data.
 * @param {String} key - The key to test & display.
 * @param {String} defaultMsg - Optional returned default message if key not found.
*/
function displaydata(node, key, defaultMsg) {
  /* jshint evil: true */

  if (!isEmpty(node[key], true) && node[key].length >= 0) {
    return document.write(node[key]);
  } else if (typeof defaultMsg !== 'undefined') {
    return document.write(defaultMsg);
  }

  return document.write(`ERROR Parsing this key: ${key}`);
}

export {
  banner,
  displaydata,
};



// WEBPACK FOOTER //
// ./js/common/Ui.js